var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOrderIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 7,
    viewBox: "0 0 9 7",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00195312 0.5C0.00195312 0.223858 0.225811 0 0.501953 0H7.50195C7.7781 0 8.00195 0.223858 8.00195 0.5C8.00195 0.776142 7.7781 1 7.50195 1H0.501953C0.225811 1 0.00195312 0.776142 0.00195312 0.5Z",
    fill: "#646464"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00195 3.5C1.00195 3.22386 1.22581 3 1.50195 3H6.50195C6.7781 3 7.00195 3.22386 7.00195 3.5C7.00195 3.77614 6.7781 4 6.50195 4H1.50195C1.22581 4 1.00195 3.77614 1.00195 3.5Z",
    fill: "#646464"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.50195 6C2.22581 6 2.00195 6.22386 2.00195 6.5C2.00195 6.77614 2.22581 7 2.50195 7H5.50195C5.7781 7 6.00195 6.77614 6.00195 6.5C6.00195 6.22386 5.7781 6 5.50195 6H2.50195Z",
    fill: "#646464"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrderIcon);
export default __webpack_public_path__ + "static/media/order-icon.13e9b513b9cd1d9ec8f94ea52ca16d53.svg";
export { ForwardRef as ReactComponent };